import { useMemo, useRef } from 'react';
import { HighlightLayerProps } from './types';
import Markdown from '../../markdown';
import { useHighlight } from '../../../contexts/highlight-provider/useHighlight';
import { hightlightColors } from '../../../constants/highlights-colors';
import { hightlightColorsAlpha } from '../../../constants/highlights-colors-alpha';

const HighlightLayer = ({ highlight, zIndex }: HighlightLayerProps) => {
  const { selectedHighlightKeyId, hoveredHighlightKeyId } = useHighlight();
  const highlightRef = useRef<HTMLDivElement>(null);

  const { color, keyId, underLine, highlightedHtml } = highlight;

  const processedMarkdown = useMemo(() => {
    const validatedColor = (() => {
      if (selectedHighlightKeyId === keyId) {
        return hightlightColors[color];
      }

      if (hoveredHighlightKeyId === keyId) {
        return hightlightColors[color];
      }

      return hightlightColorsAlpha[color];
    })();

    const validatedUderline = (() => {
      if (underLine) {
        return ` text-decoration-line: underline; text-decoration-color: #000000; text-decoration-thickness: 2px; text-decoration-style: ${underLine}; text-underline-offset: 0.2em; text-underline-position: under;`;
      }

      return '';
    })();

    const baseStyle = `background-color: ${validatedColor};${validatedUderline}; cursor: pointer; color: inherit; user-select: auto;`;

    const styledHtml = highlightedHtml.replace(
      new RegExp(`<span([^>]*?)data-highlight-keyid="${keyId}"([^>]*?)>`, 'g'),
      `<span style="${baseStyle}" data-highlight-keyid="${keyId}">`,
    );
    return styledHtml;
  }, [keyId, color, hoveredHighlightKeyId, selectedHighlightKeyId, underLine, highlightedHtml]);

  return (
    <div
      ref={highlightRef}
      className={`absolute left-0 top-0 h-full w-full z-[${zIndex}]`}
    >
      <div className="select-none text-transparent">
        <Markdown>{processedMarkdown}</Markdown>
      </div>
    </div>
  );
};

export default HighlightLayer;
